import {
  FETCH_DEEPLINK_SHIPMENT,
  FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS,
  FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_STARTED,
  FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_COMPLETED,
  FETCH_DEEPLINK_SHIPMENT_LOCATIONS,
  FETCH_DEEPLINK_SHIPMENT_FILES,
  CLEAR_DEEPLINK_SHIPMENT_DATA,
  FETCH_DEEPLINK_DEVICE_META,
  FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER,
  FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_STARTED,
  FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_COMPLETED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  shipment: {},
  files: [],
  events: [],
  logs: [],
  metrics: {},
  locations: [],
  metricsLoadingStatus: {},
  eventsStatus: statuses.idle,
  meta: {
    device: []
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_DEEPLINK_SHIPMENT:
      const { alerts, devices } = action.payload;
      const devicesWithAlerts = devices.map(d => {
        const filteredAlerts = alerts.filter(a => a.cargoId === d.cargoId);
        return {
          ...d,
          alerts: filteredAlerts,
          showAlertIcon: true,
          alertOn: !!d.projectAlertId
        };
      });
      return { ...state, shipment: { ...action.payload, devices: devicesWithAlerts } };
    case FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS:
      return { ...state, events: action.payload.events ?? [], logs: action.payload.logs ?? [] };
    case FETCH_DEEPLINK_SHIPMENT_LOCATIONS:
      return { ...state, locations: action.payload };
    case FETCH_DEEPLINK_SHIPMENT_FILES:
      return { ...state, files: action.payload };
    case FETCH_DEEPLINK_DEVICE_META:
      return { ...state, meta: { device: action.payload } };
    case FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER:
      return { ...state, metrics: { ...state.metrics, [action.identifier]: action.payload ?? [] } };
    case FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_STARTED:
      return { ...state, eventsStatus: statuses.loading };
    case FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_COMPLETED:
      return { ...state, eventsStatus: statuses.succeeded };
    case FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_STARTED:
      return {
        ...state,
        metricsLoadingStatus: {
          ...state.metricsLoadingStatus,
          [action.payload]: true
        }
      };
    case FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_COMPLETED:
      return {
        ...state,
        metricsLoadingStatus: {
          ...state.metricsLoadingStatus,
          [action.payload]: false
        }
      };
    case CLEAR_DEEPLINK_SHIPMENT_DATA:
      return defaultState;
    default:
      return state;
  }
};
